const sessionId = {
  get() {
    return window.localStorage.getItem("stats-session-id");
  },
  set(id) {
    window.localStorage.setItem("stats-session-id", id);
  },
  remove() {
    window.localStorage.removeItem("stats-session-id");
  }
};

export default sessionId;
